module.exports = __webpack_public_path__ + "static/media/corporatesBlueIcon.261a5a05.png";